import * as actions from "./action-types";

export function toggleMenu(payload) {
  return {
    type: actions.TOGGLE_MENU,
    payload
  };
}
